import React from 'react';
import LoadingSpinner from './LoadingSpinner';

/**
 * Vertical progress stepper for SSE-driven query status.
 * steps: [{ id, title }], activeId: current step id, statusMessage: subtitle on active row
 */
const AnalysisStepper = ({ steps, activeId, statusMessage }) => {
  const activeIndex = Math.max(
    0,
    steps.findIndex((s) => s.id === activeId)
  );

  return (
    <div className="min-w-[280px] max-w-md">
      <h3 className="text-sm font-semibold text-gray-900 tracking-wide mb-4">Analyzing status</h3>
      <div className="flex flex-col">
        {steps.map((step, i) => {
          const isComplete = i < activeIndex;
          const isActive = i === activeIndex;
          const isPending = i > activeIndex;

          return (
            <div key={step.id} className="flex">
              <div className="flex flex-col items-center w-10 shrink-0 mr-3">
                {isComplete && (
                  <div
                    className="w-7 h-7 rounded-full bg-emerald-500 flex items-center justify-center shrink-0 shadow-sm"
                    aria-hidden
                  >
                    <svg
                      className="w-4 h-4 text-white"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2.5}
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                  </div>
                )}
                {isActive && (
                  <div
                    className="w-7 h-7 rounded-full border-2 border-primary-500 flex items-center justify-center shrink-0 bg-white shadow-sm"
                    aria-hidden
                  >
                    <LoadingSpinner size="small" className="text-primary-600" />
                  </div>
                )}
                {isPending && (
                  <div
                    className="w-7 h-7 rounded-full border border-gray-300 text-gray-500 text-xs font-semibold flex items-center justify-center shrink-0 bg-white"
                    aria-hidden
                  >
                    {i + 1}
                  </div>
                )}
                {i < steps.length - 1 && (
                  <div
                    className={`w-0.5 min-h-[26px] mt-1 ${
                      i < activeIndex ? 'bg-emerald-400' : 'bg-gray-200'
                    }`}
                  />
                )}
              </div>
              <div className="pb-5">
                <div
                  className={`text-sm font-medium leading-5 ${
                    isPending ? 'text-gray-500' : 'text-gray-900'
                  }`}
                >
                  {step.title}
                </div>
                {isActive && statusMessage ? (
                  <div className="text-xs text-gray-500 mt-1.5 leading-relaxed">
                    {statusMessage}
                  </div>
                ) : null}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default AnalysisStepper;
